import './styles/animations.css'
import './styles/fonts.css';
import './styles/main.css';
import './styles/slider.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import renderComponents from '@helpers/renderComponents';

// Render all components
renderComponents();
